module.exports = __webpack_public_path__ + "img/784-a40e79.png";